<template>
	<div v-if="isUserAllowedInLevel5or6 && isAppContainer" class="flex-grow flex flex-col">
		<ProcessCreateComprehensiveOverviewImage v-show="pageIndex === pageIndexEnum.overviewImage" @next="next" @previous="previous" />
		<ProcessCreateComprehensiveAccident v-show="pageIndex === pageIndexEnum.accident" @next="next" />
		<ProcessCreateComprehensiveInsurance v-show="pageIndex === pageIndexEnum.insurance" @next="next" />
		<ProcessCreateComprehensiveDamageAssessor v-show="pageIndex === pageIndexEnum.damageAssessor" @next="next" />
	</div>
</template>

<script>
import CustomerRepository from '@/api/repositories/CustomerRepository';
import VehicleRepository from '@/api/repositories/VehicleRepository';
import ProcessCreateComprehensiveFinish from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveFinish';
import ProcessCreateComprehensiveDamageAssessor from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveDamageAssessor';
import ProcessCreateComprehensiveOverviewImage from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveOverviewImage';
import ProcessCreateComprehensiveInsurance from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveInsurance';
import ProcessCreateComprehensiveAccident from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveAccident';
import ProcessCreateComprehensiveRepairOrder from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveRepairOrder';
import ProcessCreateComprehensiveSignLocation from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveSignLocation';
import ProcessCreateComprehensiveSignCustomerConsultant from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveSignCustomerConsultant';
import ProcessCreateComprehensiveSignCustomer from '@/views/management/Process/Comprehensive/ProcessCreateComprehensiveSignCustomer';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'ProcessCreateComprehensive',
	components: {
		ProcessCreateComprehensiveAccident,
		ProcessCreateComprehensiveInsurance,
		ProcessCreateComprehensiveOverviewImage,
		ProcessCreateComprehensiveDamageAssessor,
	},
	mixins: [Authentication, AppContainerMixin],
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAppContainer) {
			CustomerRepository.show(this.$route.query.customer_id).then(response =>
				this.$store.commit('setProcessCreateComprehensiveCustomer', response.data),
			);

			new VehicleRepository()
				.show(this.$route.query.vehicle_id)
				.then(response => this.$store.commit('setProcessCreateComprehensiveVehicle', response.data));

			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			this.$store.commit('clearProcessCreateComprehensive');
		}
	},
	methods: {
		next() {
			this.pageIndex = this.pageRegister[++this.pageRegisterIndex];
		},
		previous() {
			const index = this.pageRegister[--this.pageRegisterIndex];
			if (index || index === 0) {
				this.pageIndex = index;
			} else {
				this.$router.push(this.$route.params.backlink);
			}
		},
	},
	watch: {
		pageIndex: function() {
			this.$emit('scrollUp', this.pageIndex);
		},
	},
	data() {
		return {
			pageRegisterIndex: 0,
			pageIndex: 0,
			pageIndexEnum: {
				overviewImage: 0,
				damageAssessor: 3,
				insurance: 2,
				accident: 1,
			},
		};
	},
	computed: {
		pageRegister() {
			return [this.pageIndexEnum.overviewImage, this.pageIndexEnum.accident, this.pageIndexEnum.insurance, this.pageIndexEnum.damageAssessor];
		},
	},
};
</script>
